import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type ScheduledReportSpecification from "./ScheduledReportSpecification";

@Model()
class ScheduledReport extends ApplicationRecord {
  static jsonapiType = "scheduled_reports";

  @Attr({ persist: false }) createdAt: string;

  @Attr() htmlUrl: string;

  @BelongsTo()
  scheduledReportSpecification: ScheduledReportSpecification;

  @Attr({ persist: false }) updatedAt: string;
}

export default ScheduledReport;
